import { render, staticRenderFns } from "./InspectionShipmentPreview.vue?vue&type=template&id=70ab24cc&"
import script from "./InspectionShipmentPreview.vue?vue&type=script&lang=js&"
export * from "./InspectionShipmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./InspectionShipmentPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports